module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "andy_ecosite.c4df867c.png" + "?" + Date.now();